<template>
    <div>
        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <router-link :to="'/birthday/template/edit?id=' + props.row.id" class="btn btn-primary text-white margin5">
                        Edit
                    </router-link>
                    <a v-on:click="deleteTemplate(props.row.id)" class="btn btn-danger text-white margin5">Hapus</a>
                    <a v-on:click="setDefault(props.row.id)" v-if="props.row.is_default == 0" class="btn btn-success text-white margin5">Set Default</a>
                </span>
                <span v-else-if="props.column.field == 'message'">
                    {{ truncateMessage(props.row.message) }}
                </span>
                <span v-else-if="props.column.field == 'is_default'">
                    <span v-if="props.row.is_default == 1" class="badge badge-success">Default</span>
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            table: {
                isLoading: false,
                columns: [
                    { label: 'Judul', field: 'title', sortable: true },
                    { label: 'Pesan', field: 'message', sortable: false },
                    { label: 'Default', field: 'is_default', sortable: true },
                    { label: 'Aksi', field: 'action', sortable: false }
                ],
                rows: [],
                total_records: 0,
                serverParams: {
                    page: 1,
                    limit: 10
                }
            }
        };
    },
    methods: {
        async loadItems() {
            this.table.isLoading = true;
            try {
                let response = await this.$store.dispatch("birthday/birthday_template_list", this.table.serverParams);
                this.table.rows = response.data.data.templates || [];
                this.table.total_records = response.data.data.total_records || 0;
            } catch (err) {
                this.$toast.error("Gagal memuat data");
            }
            this.table.isLoading = false;
        },
        async deleteTemplate(id) {
            if (confirm("Yakin ingin menghapus template ini?")) {
                try {
                    await this.$store.dispatch("birthday/birthday_template_delete", id);
                    this.$toast.success("Template berhasil dihapus");
                    this.loadItems();
                } catch (err) {
                    this.$toast.error("Gagal menghapus template");
                }
            }
        },
        async setDefault(id) {
            try {
                await this.$store.dispatch("birthday/birthday_template_set_default", id);
                this.$toast.success("Template default berhasil diubah");
                this.loadItems();
            } catch (err) {
                this.$toast.error("Gagal mengubah template default");
            }
        },
        updateParams(newProps) {
            this.table.serverParams = Object.assign({}, this.table.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ limit: params.currentPerPage });
            this.loadItems();
        },
        onSortChange() {
            this.loadItems();
        },
        onColumnFilter(params) {
            this.updateParams(params);
            this.loadItems();
        },
        truncateMessage(message) {
            if (!message) return '-';
            if (message.length <= 25) return message;
            return message.substring(0, 25) + '...';
        }
    },
    mounted() {
        this.loadItems();
    }
};
</script>

<style scoped>
.margin5 {
    margin: 5px;
}
</style>

